// extracted by mini-css-extract-plugin
export default {"page":"EFJbD","logoTrends":"HCHOj","buttonWrapper":"v0UN7 ZdH1P","button":"lpZdO"};